//Publicas
import { HomePage } from './HomePage'
import { InstructivosPage } from './InstructivosPage'

import { LoginPage } from './LoginPage'
import { RegisterPage } from './RegisterPage'
import { UserRequestPage } from './UserRequestPage'
import SolicitudEntidadPage from './SolicitudEntidadPage'
import EntidadRegistroPage from './EntidadRegistroPage'
import ForgotPasswordPage from './ForgotPasswordPage'
import ResetPasswordPage from './ResetPasswordPage'

//Privadas
import { InicioPage } from './InicioPage'
import { MetabasePage } from './MetabasePage'
//import { NuevaONGPage } from './NuevaONGPage'
import { TramitacionesPage } from './TramitacionesPage'
import { InformesPage } from './InformesPage'
import { MapaPrivPage } from './MapaPrivPage'
import { TableroPage } from './TableroPage'
import { EstadisticasPage } from './EstadisticasPage'
import { AdminUserRequestsPage } from './AdminUserRequestsPage'
import { ChangePasswordPage } from './ChangePasswordPage'
import { AdminCreateProvincialUserPage } from './AdminCreateProvincialUserPage'
import { AdminUsersPage } from './AdminUsersPage'
import { AdminOsmPage } from './AdminOsmPage'
import EntidadRequestsListPage from './EntidadRequestsListPage'
import EntidadRequestDetailPage from './EntidadRequestDetailPage'
import EventHistoryPage from './EventHistoryPage'

export {
    //paginas publicas
    HomePage,
    InstructivosPage,
    MapaPrivPage,
    TableroPage,
    EstadisticasPage,
    LoginPage,
    RegisterPage,
    UserRequestPage,
    SolicitudEntidadPage,
    EntidadRegistroPage,
    ForgotPasswordPage,
    ResetPasswordPage,
    //paginas privadas
    InicioPage,
    MetabasePage,
    //NuevaONGPage,
    TramitacionesPage,
    InformesPage,
    AdminUserRequestsPage,
    ChangePasswordPage,
    AdminCreateProvincialUserPage,
    AdminUsersPage,
    AdminOsmPage,
    EntidadRequestsListPage,
    EntidadRequestDetailPage,
    EventHistoryPage
}
